import { __require as a } from "./identity.js";
import { __require as n } from "./_overRest.js";
import { __require as q } from "./_setToString.js";
var e, t;
function v() {
  if (t) return e;
  t = 1;
  var i = a(), s = n(), o = q();
  function u(r, _) {
    return o(s(r, _, i), r + "");
  }
  return e = u, e;
}
export {
  v as __require
};
